import { connect } from "react-redux";
import CollectionList from "../../Shared/ItemCollection/CollectionList";
import * as Actions from "../../../actions/shared/itemCollectionActions";
import ExclusionsConstants from "../../../constants/ExclusionsConstants";

const mapStateToProps = (state: any) => ({
    listTitle: "Placement Exclusions",
    collections: state.placementExclusions.collections.entities,
    loaded: state.placementExclusions.collections.loaded
});

const mapDispatchToProps = (dispatch: any) => {
    return {
        fetchCollections: () => {
            dispatch(Actions.fetchCollectionList(ExclusionsConstants.ACTION_TYPE_IDENTIFIER));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionList);
